<!--suppress AngularNgOptimizedImage -->
<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- IZQUIERDA: cabecera estilo turquesa, igual que usuarios -->
      <div class="col-lg-4 col-md-12">
        <div class="card card-personal-profile">
          <div class="profile-content">
            <img class="profile-img" [src]="resolvedLeftImage" alt="Logo del grupo" />
            <div class="profile-text">
              <div class="profile-name">
                {{ param ? 'EDITAR' : 'NUEVA' }} SUCURSAL
              </div>
              <div class="profile-subtext">
                {{ gemp.nombre || 'GRUPO EMPRESARIAL' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DERECHA: formulario -->
      <div class="col-lg-8 col-md-12">
        <div class="card">
          <form [formGroup]="branchForm" class="register-form m-4" data-tour="branch-form">

            <!-- DATOS DE LA SUCURSAL -->
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>store</mat-icon>
                DATOS DE LA SUCURSAL
              </div>
              <div class="descripcion-seccion">INFORMACION GENERAL DE LA SUCURSAL</div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE</mat-label>
                    <input appUppercaseNoAccent formControlName="nombre" matInput required data-tour="branch-nombre" />
                  </mat-form-field>
                  <div *ngIf="branchForm.get('nombre')?.touched && branchForm.get('nombre')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">NOMBRE ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="branchForm.get('nombre')?.touched && branchForm.get('nombre')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>REGISTRO SANITARIO</mat-label>
                    <input appUppercaseNoAccent formControlName="registroSanitario" matInput required data-tour="branch-registro"/>
                  </mat-form-field>
                  <div *ngIf="branchForm.get('registroSanitario')?.touched && branchForm.get('registroSanitario')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">REGISTRO SANITARIO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="branchForm.get('registroSanitario')?.touched && branchForm.get('registroSanitario')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">FORMATO EJ: ABC-123456-XYZ.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>
                      {{ (branchForm.get('settlementSearch')?.value ? 'COLONIA' : 'CODIGO POSTAL') | regionWord }}
                    </mat-label>

                    <input
                      matInput
                      [matAutocomplete]="auto"
                      formControlName="settlementSearch"
                      (blur)="onSettlementBlur()" data-tour="branch-cp-colonia"/>

                    <mat-autocomplete #auto="matAutocomplete"
                                      (optionSelected)="setSelectedSettlement($event.option.value)"
                                      [displayWith]="displayFn">
                      <mat-option *ngFor="let option of settlements" [value]="option">
                        {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <!-- Conservamos los errores estandarizados -->
                  <div *ngIf="branchForm.get('settlementSearch')?.touched && branchForm.get('settlementSearch')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CODIGO POSTAL ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="branchForm.get('settlementSearch')?.touched && branchForm.get('settlementSearch')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">INGRESA UN CODIGO POSTAL VALIDO.</small>
                  </div>
                </div>

                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>DIRECCION</mat-label>
                    <textarea appUppercaseNoAccent formControlName="domicilio" matInput required data-tour="branch-domicilio"></textarea>
                  </mat-form-field>
                  <div *ngIf="branchForm.get('domicilio')?.touched && branchForm.get('domicilio')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">DOMICILIO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="branchForm.get('domicilio')?.touched && branchForm.get('domicilio')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS, NUMEROS Y CARACTERES . , _ # / - ( ).</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- DATOS DEL RESPONSABLE -->
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>badge</mat-icon>
                DATOS DEL RESPONSABLE SANITARIO
              </div>
              <div class="descripcion-seccion">PERSONA RESPONSABLE SANITARIO DE LA SUCURSAL</div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE</mat-label>
                    <input appUppercaseNoAccent formControlName="responsable" matInput required data-tour="branch-responsable"/>
                  </mat-form-field>
                  <div *ngIf="branchForm.get('responsable')?.touched && branchForm.get('responsable')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">RESPONSABLE ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="branchForm.get('responsable')?.touched && branchForm.get('responsable')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>CORREO ELECTRONICO</mat-label>
                    <input formControlName="emailResponsable" matInput required data-tour="branch-email"/>
                  </mat-form-field>
                  <div *ngIf="branchForm.get('emailResponsable')?.touched && branchForm.get('emailResponsable')?.hasError('email')" class="custom-error-below">
                    <small class="text-danger">DIRECCION DE CORREO INVALIDA.</small>
                  </div>
                  <div *ngIf="branchForm.get('emailResponsable')?.touched && branchForm.get('emailResponsable')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">CORREO RESPONSABLE ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="branchForm.get('emailResponsable')?.touched && branchForm.get('emailResponsable')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">INGRESE UNA DIRECCION DE CORREO VALIDA.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>MATRICULA</mat-label>
                    <input appUppercaseNoAccent formControlName="cedulaResponsable" matInput required data-tour="branch-cedula"/>
                  </mat-form-field>
                  <div *ngIf="branchForm.get('cedulaResponsable')?.touched && branchForm.get('cedulaResponsable')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">CEDULA RESPONSABLE ES OBLIGATORIA.</small>
                  </div>
                  <div *ngIf="branchForm.get('cedulaResponsable')?.touched && branchForm.get('cedulaResponsable')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">LA CEDULA RESPONSABLE DEBE TENER 9 DIGITOS.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>TELEFONO</mat-label>

                    <ngx-mat-intl-tel-input
                      formControlName="telefonoResponsable"
                      [preferredCountries]="preferredCountries"
                      [enablePlaceholder]="true"
                      data-tour="branch-telefono">
                    </ngx-mat-intl-tel-input>
                  </mat-form-field>

                  <div *ngIf="branchForm.get('telefonoResponsable')?.touched && branchForm.get('telefonoResponsable')?.hasError('required')" class="custom-error-below">
                    <small class="text-danger">TELEFONO RESPONSABLE ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="branchForm.get('telefonoResponsable')?.touched && branchForm.get('telefonoResponsable')?.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">INGRESE UN NUMERO DE TELEFONO VALIDO (7–20 DIGITOS, OPCIONAL + Y CODIGOS DE AREA).</small>
                  </div>
                </div>
              </div>
            </div>

            <button (click)="confirmAdd()"
                    [disabled]="!branchForm.valid"
                    [ngClass]="{
                      'button-custom': true,
                      'disabled': !branchForm.valid
                    }"
                    color="primary"
                    mat-button data-tour="branch-btn-guardar">
              {{ !branchForm.valid ? 'FORMULARIO INCOMPLETO' : param ? 'EDITAR SUCURSAL' : 'CREAR SUCURSAL' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
